import { Component, Input, Inject } from "@angular/core";
import { IntentService } from "@tylertech/intents-module";
import { IProcessStep } from "@tylertech/tyler-api-types";
@Component({
    selector: "process-step",
    templateUrl: "./processStep.tmpl.html",
    standalone: false
})
export class ProcessStepComponent
{
    @Input()
    entity: IProcessStep;

    @Input()
    enableLink: boolean;

    @Input()
    isProcessing: boolean = false;

    constructor(
        private $intentService: IntentService
    ) { }

    get complete(): boolean
    {
        return this.entity.Complete;
    }

    get locked(): boolean
    {
        return this.entity.Locked;
    }

    get showComplete(): boolean
    {
        return this.complete;
    }

    get showLocked(): boolean
    {
        return !this.complete && this.locked;
    }

    get showReady(): boolean
    {
        return !this.complete && !this.locked;
    }

    get className(): string
    {
        return this.showReady && this.enableLink ? "no-focus" : "no-focus no-pointer";
    }

    openStep(): void
    {
        if (this.showReady && this.enableLink)
        {
            this.showProgressCircular();
            setTimeout(() =>
            {
                this.$intentService.resolve("ProcessStep", "View", {
                    ProcessId: this.entity.ProcessId,
                    StepId: this.entity.StepId,
                });
                this.hideProgress();
            }, 1000);
        }
    }

    private showProgressCircular(): void
    {
        this.isProcessing = true;
    }

    private hideProgressCircular(): void
    {
        this.isProcessing = false;
    }

    hideProgress(): void
    {
        setTimeout(() =>
        {
            this.hideProgressCircular();
        }, 250);
    }
}
